import React from "react";
import styles from "./scrollable-table.module.scss";
import classNames from "classnames"
import {ScrollableTableHeaderCellTitle} from "./scrollable-table-header-cell-title";

export const ScrollableTableHeaderCell = ({headers, shouldRenderEmptyRow, useShortName}) => {
  if (shouldRenderEmptyRow || !headers || headers.length < 1) {
    return null;
  }

  return headers?.map((header, index: Number) => {
    const cell = header.isRecentForm ? styles.table_header_large_cell : styles.table_header_cell
    const hasBorder: Boolean = ((headers[index - 1]?.isMajor && !header?.isMajor) || index === 0);

    const className = classNames(cell,
      {[styles.table_cell_border]: hasBorder},
      {[styles.table_text_bold_cell]: header.isBold}
    );

    const cellProps = {
      className,
      header,
      useShortName
    }

    return <ScrollableTableHeaderCellTitle {...cellProps} key={index}/>
  })
}